import { ReactComponent as InfoIcon } from "assets/icons/info.svg";
import { Text } from "iparque-components";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PasswordRequirementsPopup from "../PasswordRequirementsPopup";
import { StyledButton } from "./styles";

interface Props {
  visible: boolean;
  deadline: string;
  onClose: () => void;
  onContinue: () => void;
  onClickUrl: () => void;
}

const PasswordRequirementsWarningPopup: React.FC<Props> = ({
  visible,
  deadline,
  onClose,
  onContinue,
  onClickUrl,
}) => {
  const { t } = useTranslation();

  return (
    <PasswordRequirementsPopup
      visible={visible}
      onClose={onClose}
      onClickButton={onContinue}
      buttonText={t("3960") /* Continuar */}
      icon={<InfoIcon />}
    >
      <Text elementType="p" variant="body6">
        {t("7987") /* Caro(a) Utilizador(a) */}
      </Text>
      <Text className="mt-10" elementType="p" variant="body6">
        {
          t(
            "7990"
          ) /* Devido a uma revisão da nossa política de segurança, informamos que a
          sua palavra-passe deverá ser alterada de forma a cumprir com os novos requisitos
          definidos. */
        }
      </Text>
      <Text variant="body6">
        <StyledButton onClick={onClickUrl} variant="link" color="secondary">
          <b>
            {
              t(
                "8199"
              ) /* Clique aqui para alterar a sua palavra-passe agora. */
            }
          </b>
        </StyledButton>
      </Text>
      <Text className="mt-10" variant="body6">
        <Trans
          i18nKey="8013"
          tOptions={{ interpolation: { escapeValue: false } }}
          values={{ date: deadline }}
          components={{ b: <b /> }}
        />
        {/*  Esta alteração deve ser efetuada até <b>{{date}}</b>. */}
      </Text>
    </PasswordRequirementsPopup>
  );
};

export default PasswordRequirementsWarningPopup;
